/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bishop/collections/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * Direction of a single-column sort.

 - SORT_DIRECTION_UNSPECIFIED: Default; ascending.
 - SORT_DIRECTION_ASCENDING: Smallest value first.
 - SORT_DIRECTION_DESCENDING: Largest value first.
 */
export type V1SortDirection =
  (typeof V1SortDirection)[keyof typeof V1SortDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1SortDirection = {
  SORT_DIRECTION_UNSPECIFIED: 'SORT_DIRECTION_UNSPECIFIED',
  SORT_DIRECTION_ASCENDING: 'SORT_DIRECTION_ASCENDING',
  SORT_DIRECTION_DESCENDING: 'SORT_DIRECTION_DESCENDING',
} as const;
